var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2995 2.58785L15.1326 6.28441C15.3826 6.79898 16.0492 7.29256 16.6117 7.38707L19.9342 7.94365C22.059 8.30071 22.559 9.85495 21.0278 11.3882L18.4448 13.9926C18.0073 14.4336 17.7678 15.2842 17.9031 15.8934L18.6427 19.1173C19.226 21.6692 17.8823 22.6564 15.643 21.3227L12.5288 19.4639C11.9664 19.1279 11.0394 19.1279 10.4665 19.4639L7.35228 21.3227C5.12335 22.6564 3.76934 21.6587 4.35262 19.1173L5.09212 15.8934C5.22751 15.2842 4.98796 14.4336 4.5505 13.9926L1.96746 11.3882C0.446793 9.85495 0.936324 8.30071 3.06108 7.94365L6.38364 7.38707C6.93566 7.29256 7.60225 6.79898 7.85222 6.28441L9.68533 2.58785C10.6852 0.582046 12.31 0.582046 13.2995 2.58785Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStar);
export default __webpack_public_path__ + "static/media/whiteStar.d7118528f623fbdc0659db577c73ce89.svg";
export { ForwardRef as ReactComponent };